// v2/hooks/useTarjetaVecinoV2.js
//
// Wrapper del endpoint /v2/inscripcion/validar-inscrito con estado de UI.
// Diferencia clave vs useTarjetaVecino (v1): si la API no responde, el
// componente debe BLOQUEAR el avance — este hook expone `bloqueado`.

import { useState, useCallback } from 'react';
import InscripcionV2 from '../service/inscripcion.service.js';
import { codigoError, mensajeDeError } from '../service/client.js';

export function useTarjetaVecinoV2() {
  const [validando, setValidando] = useState(false);
  const [resultado, setResultado] = useState(null); // { rut, esVecino, estado, ... }
  const [error, setError] = useState(null);
  const [bloqueado, setBloqueado] = useState(false);

  const validar = useCallback(async (rut) => {
    setValidando(true);
    setError(null);
    setBloqueado(false);
    try {
      const out = await InscripcionV2.validarInscrito(rut);
      setResultado(out);
      return out;
    } catch (err) {
      const code = codigoError(err);
      setError({ code, mensaje: mensajeDeError(err) });
      // BLOQUEANTE: si la API de TV no responde, el flujo debe detenerse.
      if (code === 'TV_API_NO_RESPONDE') setBloqueado(true);
      return null;
    } finally {
      setValidando(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResultado(null);
    setError(null);
    setBloqueado(false);
  }, []);

  return {
    validar,
    reset,
    validando,
    resultado,
    esVecino: resultado?.esVecino ?? null,
    error,
    bloqueado
  };
}

export default useTarjetaVecinoV2;
